<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <v-tour name="vuexyTour" :steps="steps" :options="{ highlight: true }" :callbacks="{
      onSkip: this.stopTour,
      onFinish: this.stopTour
    }" >
        <template slot-scope="tour">
            <transition name="fade">
                <v-step
                    v-if="tour.currentStep === index"
                    v-for="(step, index) of tour.steps"
                    :key="index"
                    :step="step"
                    :previous-step="tour.previousStep"
                    :next-step="tour.nextStep"
                    :stop="tour.stop"
                    :is-first="tour.isFirst"
                    :is-last="tour.isLast"
                    :labels="tour.labels">

                    <div slot="actions" class="flex justify-center">
                        <vs-button
                            size="small"
                            class="mr-3"
                            @click="tour.skip()"
                            icon-pack="feather"
                            icon="icon-x"
                            icon-after
                            color="#fff"
                            type="border"
                            v-if="tour.currentStep != tour.steps.length - 1">
                            Saltar
                        </vs-button>

                        <vs-button
                            size="small"
                            @click="tour.previousStep"
                            icon-pack="feather"
                            icon="icon-chevrons-left"
                            color="#fff"
                            type="border"
                            class="mr-3"
                            v-if="tour.currentStep">
                            Anterior
                        </vs-button>

                        <vs-button
                            size="small"
                            @click="tour.nextStep"
                            icon-pack="feather"
                            icon="icon-chevrons-right"
                            icon-after
                            color="#fff"
                            type="border"
                            class="btn-tour-next"
                            v-if="tour.currentStep != tour.steps.length - 1">
                            Siguiente
                        </vs-button>

                        <vs-button
                            size="small"
                            @click="tour.finish()"
                            icon-pack="feather"
                            icon="icon-check-circle"
                            icon-after
                            color="#fff"
                            type="border"
                            class="btn-tour-finish"
                            v-if="tour.currentStep == tour.steps.length - 1">
                            Finalizar
                        </vs-button>
                    </div>

                </v-step>
            </transition>
        </template>
    </v-tour>
</template>

<script>
import Cookies from 'js-cookie';

export default{
  name: 'vx-tour',
  props: {
      steps: {
          required: true,
          type: Array
      }
  },
  data() {
    return {
      myCallbacks: {
        onSkip: this.stopTour,
        onFinish: () => {
          console.log("pasa")
        }
      }
    }
  },
  methods: {
    stopTour() {
      console.log("cambiando cookies")
      Cookies.set("skipTour", true, { expires: 365 })
    },
  },
  watch: {
    '$route.path'() {
      this.$tours['vuexyTour'].stop()
    }
  },
  mounted() {
      this.$tours['vuexyTour'].start()
  }
}
</script>

<style lang="scss">
.v-tour .v-step .v-step__header {
  font-size: 1.2em;
  color: #fff;
  font-weight: 600;
  background-color: rgba(var(--vs-success),1);
}
.v-tour__target--relative {
  position: relative;
}
.v-tour__target--highlighted {
  -webkit-box-shadow: 0 0 0 4px rgba(var(--vs-success),.60)!important;
  border-radius: 5px;
  pointer-events: auto;
  z-index: 9999;
}


/*.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.8);
  overflow: visible!important;
}*/
.v-tour {
    .v-step {
        z-index: 55000;
        background-color: rgba(var(--vs-success),1);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

        .v-step__arrow {
            border-color: rgba(var(--vs-success),1);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }
    }
}
</style>
